import { useQuery } from "@apollo/client";
import { Box, Button } from "@chakra-ui/react";
import AddIcon from "@material-ui/icons/Add";
import MaterialTable, { MTableToolbar } from "material-table";
import * as React from "react";
import { useHistory } from "react-router-dom";
import createPersistedState from "use-persisted-state";
import MaterialTableCustomSort from "../Misc/MaterialTableCustomSort";
import { BRANDS_QUERY } from "../Product/hooks/useBrands";
interface Props {}
const columns = [
  {
    id: "brandName",
    name: "Brand Name",
  },
];
const ViewBrands: React.FC<Props> = () => {
  const useCounterState = createPersistedState("sortQueryBrand");
  const [sortQueryBrand, setSortQueryBrand] = useCounterState("brandName:asc");
  const tableRef = React.useRef(null);

  const history = useHistory();
  const { refetch } = useQuery(BRANDS_QUERY, {
    skip: true,
  });

  const handleEditClick = (id: string) => {
    history.push({
      pathname: `/admin/brand-form/${id}`,
    });
  };

  const handleAddClick = () => {
    history.push({
      pathname: "/admin/brand-form",
    });
  };

  return (
    <>
      <Button
        colorScheme="blue"
        onClick={handleAddClick}
        className="add-btn"
        m="3"
        size="sm"
        leftIcon={<AddIcon />}
        textTransform="uppercase"
      >
        Add Brand
      </Button>
      <div>
        <MaterialTable
          tableRef={tableRef}
          title="Brand"
          columns={[
            { title: "Brand Name", field: "brandName", sorting: false },
          ]}
          components={{
            Toolbar: (props) => (
              <Box display="flex" w="100%" justifyContent="space-between">
                <Box flex="1">
                  <MTableToolbar {...props} />
                </Box>
                <MaterialTableCustomSort
                  sort={sortQueryBrand}
                  setSort={setSortQueryBrand}
                  materialTableRef={tableRef}
                  columns={columns}
                />
              </Box>
            ),
          }}
          actions={[
            {
              icon: "edit",
              tooltip: "Edit Brand",
              onClick: (event, rowData: any) => {
                handleEditClick(rowData.id);
              },
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            sorting: false,
            headerStyle: {
              zIndex: "unset",
            },
          }}
          data={(query) =>
            new Promise((resolve, reject) => {
              refetch({
                where: {
                  brandName_contains: query.search,
                },
                sort: sortQueryBrand,
                start: query.page * query.pageSize,
                limit: query.pageSize,
              })
                .then((res) => {
                  const {
                    data: {
                      brandsConnection: { values, aggregate },
                    },
                  } = res;
                  const newData = values.map((item: any) => ({
                    id: item.id,
                    brandName: item.brandName,
                  }));
                  resolve({
                    data: newData,
                    page: query.page,
                    totalCount: aggregate.totalCount,
                  });
                })
                .catch((err) => console.log(err));
            })
          }
        />
      </div>
    </>
  );
};

export default ViewBrands;
